module.exports = __webpack_public_path__ + "static/media/folder-minus.36de73ff.svg";